module.exports = __webpack_public_path__ + "static/media/Dotnet.ff0e2411.png";